import { useState, Fragment, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./goMap.module.scss";
import { useTranslation } from "react-i18next";
import { Card, Tooltip, Checkbox, Typography, Button, Grid, message } from "antd";
import { Map, Marker, ZoomControl, Popup, TileLayer, MapControl } from "react-leaflet";
import easyButton from "leaflet-easybutton";
import MarkerClusterGroup from "react-leaflet-markercluster";
import Control from "react-leaflet-control";
import L, { Icon, divIcon } from "leaflet";
import { TiLocation } from "react-icons/ti";
import { RiMapPinLine } from "react-icons/ri";
import { ControlOutlined } from "@ant-design/icons";

import { renderToStaticMarkup } from "react-dom/server";
import { TimestampToDate } from "Utility/Fetch";

import { useAppSelector, useAppDispatch } from "store/hook";
import { useStatistic, useDeviceStatus } from "./queries";
import { setDeviceId, setCenterPosition, setIsEdit } from "../../goSlice";
import { TableData } from "Utility/Types/status_identity_get_set";

import YellowMan from "./../../../../image/Yellow_man.png";
import { errorMonitor } from "events";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const MapIcon = (status: string) => {
  return new Icon({
    iconUrl:
      status === "alarm"
        ? "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png"
        : "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [35, 50],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
};

function GoMap(this: any, props: any) {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const { deviceId, ticketData, centerPosition, isEdit } = useAppSelector((state) => state.goPage);

  const [map, setMap] = useState<any>(null);
  const [position, setPosition] = useState(null);

  const [currentPosition, setCurrentPosition] = useState<any>([0, 0]);

  const customMarkerIcon = (health: string, signal: string, index: number) => {
    const healthNum = health === "up" ? 3 : health === "warning" ? 2 : health === "critical" ? 1 : 0;
    const signalNum =
      signal === "excellent" ? 4 : signal === "good" ? 3 : signal === "fair" ? 2 : signal === "poor" ? 1 : 0;
    let color: any = {};
    if (healthNum <= signalNum - 1) {
      healthNum === 3
        ? (color = { color: "#28a745", fontSize: "2rem" }) // up
        : healthNum === 2
        ? (color = { color: "#ffc107", fontSize: "2rem" }) // warning
        : healthNum === 1
        ? (color = { color: "#dc3545", fontSize: "2rem" }) // critical
        : healthNum === 0
        ? (color = { color: "#343a40", fontSize: "2rem" }) // offline
        : (color = {});
    } else {
      signalNum === 4
        ? (color = { color: "#28a745", fontSize: "2rem" }) // excellent
        : signalNum === 3
        ? (color = { color: "#ffc107", fontSize: "2rem" }) // good
        : signalNum === 2
        ? (color = { color: "#dc3545", fontSize: "2rem" }) // fair
        : signalNum === 1
        ? (color = { color: "#343a40", fontSize: "2rem" }) // poor
        : signalNum === 0
        ? (color = { color: "gray", fontSize: "2rem" }) // na
        : (color = {});
    }

    return divIcon({
      shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
      shadowSize: [50, 50],
      shadowAnchor: [50, 50],
      html: renderToStaticMarkup(
        <div key={index}>
          <TiLocation style={color} />
        </div>
      ),
    });
  };

  const currentMarkerIcon = () => {
    return new Icon({
      iconUrl: YellowMan,
      shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
      // shadowUrl: markerShadow,
      iconSize: [35, 37],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [44, 30],
    });
  };

  // const result = ticketData?.filter(item => item.id)

  const screens = useBreakpoint();

  // const disp = useAppDispatch();
  // const navigate = useNavigate();
  // const { t } = useTranslation();
  // const [viewport, setViewPort] = useState({
  //   center: [24.793256, 121.013987],
  //   zoom: 8,
  // });

  // const [disableClusteringAtZoom] = useState(15);
  // const tableData = maintainedStatus || [];
  // const [maintainedItem, setMaintainedItem] = useState(tableData);
  // const [showDeviceOnMap, setShowDeviceOnMap] = useState(false);
  // const [showLocation, setShowLocation] = useState(false);
  // const [showAlarmOnly, setShowAlarmOnly] = useState(false);
  // const [isHover, setIsHover] = useState(false);

  // const health = deviceStatistic?.health;
  // const signal = deviceStatistic?.sim;

  // useEffect(() => {
  //   setMaintainedItem(tableData);
  // }, [tableData.length]);

  // useEffect(() => {
  //   const localViewport = localStorage.getItem("viewport");
  //   if (!localViewport) {
  //     return;
  //   }
  //   setViewPort(JSON.parse(localViewport));
  // }, []);

  // const onViewportChanged = (viewport: any) => {
  //   localStorage.setItem("viewport", JSON.stringify(viewport));
  // };

  // useEffect(() => {}, [deviceId]);

  // ==================================  取得使用地理位置權限 START ==================================
  const handlePermissionsGranted = () => {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        // PermissionStatus.status => Returns the state of a requested permission; one of 'granted', 'denied', or 'prompt'. Later versions of the specification replace this with PermissionStatus.state.
        if (result.state === "granted" || "prompt") {
          getCoordinates();
        } else if (result.state === "denied") {
          handlePermissionsGranted();
          result.onchange = () => {
            handlePermissionsGranted();
          };
        }
        // Don't do anything if the permission was denied.
      });
    } else if (navigator.geolocation) {
      getCoordinates();
    }
  };
  // ==================================  取得使用地理位置權限 END ==================================

  // ==================================  取得座標位置 START ==================================
  const successCallback = (position: any) => {
    const coordinates = [position.coords.latitude, position.coords.longitude];
    setCurrentPosition(coordinates);
    dispatch(setCenterPosition(coordinates));
  };

  const errorCallback = (error: any) => {
    // 使用手機版瀏覽器會進入這裡
    // 出現錯誤 [object GeolocationPositionError]
    // error.message 可查看錯誤訊息
    // console.log("error", error);

    // To uppercase the first letter of each words
    const errMessage = error.message.split(" "); // string to array
    let MessageStr: any = [];
    errMessage.map((item: string) => {
      MessageStr.push(item.charAt(0).toUpperCase() + item.slice(1));
    });
    MessageStr = MessageStr.join(" "); // array to string

    MessageStr === "User Denied Geolocation"
      ? message.error(t("ISMS.UserDeniedGeolocation"))
      : message.error(t("ISMS.UserDeniedGeolocation"));
  };

  const getCoordinates = () => {
    if (!navigator.geolocation) {
      message.error("Geolocation is not supported by your browser");
      return;
    } else {
      navigator.geolocation.getCurrentPosition((position: any) => {
        const coordinates = [position.coords.latitude, position.coords.longitude];

        setCurrentPosition(coordinates);
        if (!isEdit) dispatch(setCenterPosition(coordinates)); // 編輯設備座標後，避免將中心設在目前位置
      }, errorCallback);
    }
  };
  // ==================================  取得座標位置 END ==================================

  useEffect(() => {
    handlePermissionsGranted();
    dispatch(setIsEdit(false));
  }, []);

  return (
    <>
      {/* 沒有 deviceId 時，顯示以下尺寸 MAP */}
      {deviceId === "" && ticketData && (
        <div className={styles.Card}>
          <Map
            center={centerPosition}
            zoom={centerPosition[0] === 0 && centerPosition[1] === 0 ? 3 : 13} // 當座標位在 [0,0] 時, zoom 級距調小
            scrollWheelZoom={true} // mouse scroll wheel 縮放
            wheelPxPerZoomLevel={50} // mouse scroll wheel 縮放級距(number 越小縮放越大)
            // FIXME: 刷新頁面停留在前一次放大級距
            // viewport={viewport}
            // onViewportChanged={onViewportChanged}
            style={{ height: "calc(100vh - 113px - 85px - 62px)" }}
            zoomControl={false}
            createLeafletElement={(props: any) => {
              setMap(props);
            }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {/* Put <MarkerClusterGroup {...props} /> inside react-leaflet after <TileLayer /> */}

            <Marker
              key={"current"}
              position={currentPosition}
              icon={currentMarkerIcon()}
              onclick={() => {
                handlePermissionsGranted();
              }}
            ></Marker>

            {Object.entries(ticketData?.node_inf)?.map((item: any, index: number) => {
              const position = item[1].lat_long === null ? [0, 0] : item[1].lat_long;
              return (
                <Marker
                  key={index}
                  position={position}
                  icon={customMarkerIcon(item[1].health, item[1].signal, item[0])}
                  onclick={() => {
                    dispatch(setDeviceId(item[0]));
                    dispatch(setCenterPosition(position));
                  }}
                ></Marker>
              );
            })}
            <ZoomControl position="bottomleft" />
            <Control position="bottomleft">
              <div style={{ border: "2px solid rgba(0, 0, 0, 0.2)", borderRadius: "4px" }}>
                <Button className={styles.mapButton} onClick={() => handlePermissionsGranted()}>
                  <RiMapPinLine style={{ height: "18px", width: "18px" }} />
                </Button>
              </div>
            </Control>
          </Map>
        </div>
      )}

      {/* 有 deviceId 時，顯示以下尺寸 MAP */}
      {deviceId && ticketData && (
        <div className={styles.Card}>
          <Map
            center={centerPosition}
            zoom={centerPosition[0] === 0 && centerPosition[1] === 0 ? 3 : 13} // 當座標位在 [0,0] 時, zoom 級距調小
            scrollWheelZoom={true} // mouse scroll wheel 縮放
            wheelPxPerZoomLevel={50} // mouse scroll wheel 縮放級距(number 越小縮放越大)
            // FIXME: 刷新頁面停留在前一次放大級距
            // viewport={viewport}
            // onViewportChanged={onViewportChanged}
            // style={screens.xs ? { height: "43vh" } : { height: "52vh" }}
            style={{ height: "43vh" }}
            zoomControl={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {/* Put <MarkerClusterGroup {...props} /> inside react-leaflet after <TileLayer /> */}

            <Marker
              key={"current"}
              position={currentPosition}
              icon={currentMarkerIcon()}
              onclick={() => {
                handlePermissionsGranted();
              }}
            ></Marker>

            {Object.entries(ticketData.node_inf)?.map((item: any, index: number) => {
              const position = item[1].lat_long === null ? [0, 0] : item[1].lat_long;
              return (
                <Marker
                  key={index}
                  position={position}
                  icon={customMarkerIcon(item[1].health, item[1].signal, item[0])}
                  onclick={() => {
                    dispatch(setDeviceId(item[0]));
                    dispatch(setCenterPosition(position));
                  }}
                ></Marker>
              );
            })}
            <ZoomControl position="bottomleft" />
            <Control position="bottomleft">
              <div style={{ border: "2px solid rgba(0, 0, 0, 0.2)", borderRadius: "4px" }}>
                <Button className={styles.mapButton} onClick={() => handlePermissionsGranted()}>
                  <RiMapPinLine style={{ height: "18px", width: "18px" }} />
                </Button>
              </div>
            </Control>
          </Map>
        </div>
      )}
    </>
  );
}

export default GoMap;
